/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountIssues {
  MISSING_PAYMENT_METHOD = 'MISSING_PAYMENT_METHOD',
  PAST_DUE = 'PAST_DUE',
  PAYMENT_DECLINED = 'PAYMENT_DECLINED',
}

export enum ActionType {
  LEARN = 'LEARN',
  MEDITATE = 'MEDITATE',
  MOVE = 'MOVE',
}

export enum ArticleType {
  ARTICLE = 'ARTICLE',
  AUDIO = 'AUDIO',
  LIVE = 'LIVE',
  POSE = 'POSE',
  VIDEO = 'VIDEO',
}

export enum CancelSubscriptionErrorCode {
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',
  SUBSCRIPTION_UNSUPPORTED_ACTION = 'SUBSCRIPTION_UNSUPPORTED_ACTION',
  TEMPORARILY_UNAVAILABLE = 'TEMPORARILY_UNAVAILABLE',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export enum CardType {
  amex = 'amex',
  diners = 'diners',
  discover = 'discover',
  jcb = 'jcb',
  mastercard = 'mastercard',
  unionpay = 'unionpay',
  visa = 'visa',
}

export enum ClassOrderBy {
  RANDOM = 'RANDOM',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
}

export enum ContentGroupType {
  CAROUSEL = 'CAROUSEL',
}

export enum CouponDiscountType {
  DOLLARS_OFF = 'DOLLARS_OFF',
  PERCENT_OFF = 'PERCENT_OFF',
}

export enum CouponItemType {
  COURSE = 'COURSE',
}

export enum CourierCategoryType {
  LIVE_REGISTRATION = 'LIVE_REGISTRATION',
}

export enum CourierStatus {
  OPTED_IN = 'OPTED_IN',
  OPTED_OUT = 'OPTED_OUT',
}

/**
 * Extends `enum MembershipTier`
 */
export enum CourseAccess {
  A_La_Carte = 'A_La_Carte',
  Digital = 'Digital',
  Free = 'Free',
  Premium = 'Premium',
}

export enum CourseAccessType {
  A_LA_CARTE = 'A_LA_CARTE',
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
  SUBSCRIBED = 'SUBSCRIBED',
}

export enum CourseModuleType {
  ARTICLE = 'ARTICLE',
  AUDIO = 'AUDIO',
  LIVE = 'LIVE',
  PDF = 'PDF',
  QUIZ = 'QUIZ',
  VIDEO = 'VIDEO',
}

export enum CourseOrderBy {
  RANDOM = 'RANDOM',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
}

export enum CourseType {
  CHALLENGE = 'CHALLENGE',
  PODCAST = 'PODCAST',
  PREMIUM_TRAINING = 'PREMIUM_TRAINING',
  WORKSHOP = 'WORKSHOP',
}

export enum CreatePaymentAndSubscriptionAuthStatus {
  AUTHORIZED = 'AUTHORIZED',
  PENDING = 'PENDING',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export enum CreatePaymentAndSubscriptionErrorCode {
  CARD_BALANCE_INSUFFICIENT = 'CARD_BALANCE_INSUFFICIENT',
  CARD_BLOCKED = 'CARD_BLOCKED',
  CARD_CVV_DECLINED = 'CARD_CVV_DECLINED',
  CARD_DECLINED = 'CARD_DECLINED',
  CARD_EXPIRED = 'CARD_EXPIRED',
  CARD_NUMBER_INVALID = 'CARD_NUMBER_INVALID',
  CREATE_SUBSCRIPTION_ALREADY_SUBSCRIBED = 'CREATE_SUBSCRIPTION_ALREADY_SUBSCRIBED',
  CREATE_SUBSCRIPTION_CARD_DECLINED = 'CREATE_SUBSCRIPTION_CARD_DECLINED',
  CREATE_SUBSCRIPTION_GENERIC_ERROR = 'CREATE_SUBSCRIPTION_GENERIC_ERROR',
  CREATE_SUBSCRIPTION_INVALID_PLAN = 'CREATE_SUBSCRIPTION_INVALID_PLAN',
  CREATE_SUBSCRIPTION_PAYMENT_ERROR = 'CREATE_SUBSCRIPTION_PAYMENT_ERROR',
  CREATE_SUBSCRIPTION_POSTAL_CODE_ERROR = 'CREATE_SUBSCRIPTION_POSTAL_CODE_ERROR',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  TRANSACTION_CANCELED = 'TRANSACTION_CANCELED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
}

export enum CreateSubscriptionErrorCode {
  CREATE_SUBSCRIPTION_ALREADY_SUBSCRIBED = 'CREATE_SUBSCRIPTION_ALREADY_SUBSCRIBED',
  CREATE_SUBSCRIPTION_CARD_DECLINED = 'CREATE_SUBSCRIPTION_CARD_DECLINED',
  CREATE_SUBSCRIPTION_GENERIC_ERROR = 'CREATE_SUBSCRIPTION_GENERIC_ERROR',
  CREATE_SUBSCRIPTION_INVALID_PLAN = 'CREATE_SUBSCRIPTION_INVALID_PLAN',
  CREATE_SUBSCRIPTION_PAYMENT_ERROR = 'CREATE_SUBSCRIPTION_PAYMENT_ERROR',
  CREATE_SUBSCRIPTION_POSTAL_CODE_ERROR = 'CREATE_SUBSCRIPTION_POSTAL_CODE_ERROR',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export enum CurrencyCode {
  ARS = 'ARS',
  AUD = 'AUD',
  CAD = 'CAD',
  EUR = 'EUR',
  GBP = 'GBP',
  MXN = 'MXN',
  NZD = 'NZD',
  USD = 'USD',
}

export enum CurrentUserLiveRegistrationErrorCode {
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export enum CurrentUser_ActivityType {
  CLASS = 'CLASS',
  MEDITATION = 'MEDITATION',
  SERIES_EPISODE = 'SERIES_EPISODE',
}

export enum HomepageHeroContent_VisibleTo {
  NONPAID = 'NONPAID',
  PAID = 'PAID',
}

export enum Language {
  ENGLISH = 'ENGLISH',
  SPANISH = 'SPANISH',
}

export enum LiveOrderBy {
  RANDOM = 'RANDOM',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
}

export enum LogConsumptionTrackingType {
  ARTICLE = 'ARTICLE',
  CLASS = 'CLASS',
  COURSE = 'COURSE',
  COURSECLASS = 'COURSECLASS',
  LIVE = 'LIVE',
  MEDITATION = 'MEDITATION',
  SERIES = 'SERIES',
}

export enum MediaPositionContentType {
  CLASS = 'CLASS',
  COURSE = 'COURSE',
  MEDITATION = 'MEDITATION',
  SERIES = 'SERIES',
}

export enum MeditationOrderBy {
  RANDOM = 'RANDOM',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
}

export enum MembershipPlanInterval {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

/**
 * Using title case here to maintain case used in external marketing services
 * In general, enums should be SCREAMING_SNAKE_CASE
 * NOTE: `Digital` is our internal name for the user-facing term `Basic`
 */
export enum MembershipTier {
  Digital = 'Digital',
  Free = 'Free',
  Premium = 'Premium',
}

export enum MigrationStatus {
  MIGRATED = 'MIGRATED',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  VALIDATION_PASSED = 'VALIDATION_PASSED',
  VALIDATION_PENDING = 'VALIDATION_PENDING',
}

export enum PageManagerContentGroupDisplayType {
  CAROUSEL = 'CAROUSEL',
}

/**
 * Types here should match the `type` column value in `pm_sections` database table.
 * If `fields` should be editable by admins, add corresponding key to `FieldsByPageManagerSectionType`
 */
export enum PageManagerSectionType {
  COMPONENT = 'COMPONENT',
  CONTENT_GROUP = 'CONTENT_GROUP',
}

export enum Platform {
  ANDROID_MOBILE_APP = 'ANDROID_MOBILE_APP',
  ANDROID_TV = 'ANDROID_TV',
  IOS_MOBILE_APP = 'IOS_MOBILE_APP',
  IOS_TV = 'IOS_TV',
}

export enum PracticeType {
  DEFAULT = 'DEFAULT',
  PRANAYAMA = 'PRANAYAMA',
}

export enum RegisterLiveErrorCode {
  MISSING_FIELDS = 'MISSING_FIELDS',
  NOT_FOUND = 'NOT_FOUND',
  REGISTER_LIVE_ALREADY_REGISTERED = 'REGISTER_LIVE_ALREADY_REGISTERED',
  REGISTER_LIVE_DAILY_LIMIT_EXCEEDED = 'REGISTER_LIVE_DAILY_LIMIT_EXCEEDED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export enum RequestFeatureFlag {
  USE_GAIA_SOURCE = 'USE_GAIA_SOURCE',
}

export enum SaleValueType {
  PERCENTAGE = 'PERCENTAGE',
}

export enum SiteVars_Platform {
  MOBILE = 'MOBILE',
  WEB = 'WEB',
}

export enum SubscriptionOffer {
  ANNUAL = 'ANNUAL',
  BASIC_3_MONTH_CANCEL_DEFLECT = 'BASIC_3_MONTH_CANCEL_DEFLECT',
  BASIC_3_MONTH_PROMO = 'BASIC_3_MONTH_PROMO',
  DIGITAL = 'DIGITAL',
  PREMIUM = 'PREMIUM',
  WINBACK_ANNUAL = 'WINBACK_ANNUAL',
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
  PAST_DUE = 'PAST_DUE',
  TRIALING = 'TRIALING',
}

export enum TemplateStringType {
  CHECKOUT = 'CHECKOUT',
}

export enum ToggleFavoriteType {
  ecourse = 'ecourse',
  playlist = 'playlist',
  post = 'post',
  teacher = 'teacher',
}

export enum TransactionStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}

export enum UpdatePaymentMethodErrorCode {
  CARD_BALANCE_INSUFFICIENT = 'CARD_BALANCE_INSUFFICIENT',
  CARD_BLOCKED = 'CARD_BLOCKED',
  CARD_CVV_DECLINED = 'CARD_CVV_DECLINED',
  CARD_DECLINED = 'CARD_DECLINED',
  CARD_EXPIRED = 'CARD_EXPIRED',
  CARD_NUMBER_INVALID = 'CARD_NUMBER_INVALID',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',
  TEMPORARILY_UNAVAILABLE = 'TEMPORARILY_UNAVAILABLE',
  TRANSACTION_CANCELED = 'TRANSACTION_CANCELED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export enum UserFavoriteType {
  ARTICLE = 'ARTICLE',
  CLASS = 'CLASS',
  MEDITATION = 'MEDITATION',
  PLAYLIST = 'PLAYLIST',
  TEACHER = 'TEACHER',
}

export enum ZoomType {
  MEETING = 'MEETING',
  WEBINAR = 'WEBINAR',
}

export interface ClassFilter {
  language?: Language | null;
  categoryId?: string | null;
  tagId?: string | null;
  practiceType?: PracticeType | null;
  ids?: (string | null)[] | null;
}

export interface ClientVersionInfo {
  version: string;
  platform: Platform;
}

export interface CouponInput {
  coupon_code: string;
  discount_type: CouponDiscountType;
  discount_value: number;
  expires?: any | null;
  max_uses?: number | null;
  max_uses_per_user?: number | null;
  notes?: string | null;
}

export interface CouponItemInput {
  coupon_id: string;
  item_type: CouponItemType;
  item_id: string;
}

export interface CurrentUserCourseFilter {
  language?: Language | null;
  course_type?: CourseType | null;
  is_active?: boolean | null;
  is_purchased?: boolean | null;
  is_complete?: boolean | null;
}

export interface FieldsByPageManagerSectionType {
  content_group?: PageManagerContentGroupFieldsInput | null;
}

export interface PageManagerContentGroupFieldsInput {
  display_type?: PageManagerContentGroupDisplayType | null;
  heading?: string | null;
  content_list?: string[] | null;
}

export interface StreamActivityCommentInfo {
  text: string;
}

export interface Where {
  eq?: string | null;
  like?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
